import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { WalletManagementDetailModel } from 'src/app/models/wallet/wallet-management-detail.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletManagementDetailService {

  constructor(private _httpClient: HttpClient) { }

  createWalletManagementDetail(walletManagementId: number): Observable<WalletManagementDetailModel> {
    return this._httpClient.post<WalletManagementDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.CreateAsync}/${walletManagementId}`,
      walletManagementId);
  }

  deleteWalletManagementDetail(walletManagementId: number): Observable<WalletManagementDetailModel> {
    return this._httpClient.delete<WalletManagementDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.DeleteAsync}/${walletManagementId}`);
  }

  getAllWalletManagementDetails(): Observable<Array<WalletManagementDetailModel>> {
    return this._httpClient.get<Array<WalletManagementDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.GetAllWalletManagementDetailsAsync}`);
  }

  getByWalletManagementId(walletManagementId: number): Observable<Array<WalletManagementDetailModel>> {
    return this._httpClient.get<Array<WalletManagementDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.GetByWalletManagementIdAsync}/${walletManagementId}`);
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.GetColumnsForDetailCaptureAsync}`);
  }

  getWalletManagementDetailById(walletManagementDetailId: number): Observable<WalletManagementDetailModel> {
    return this._httpClient.get<WalletManagementDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.GetByIdAsync}/${walletManagementDetailId}`)
  }

  getWalletManagementDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, walletManagementId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant)
      .set('walletManagementId', walletManagementId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagementDetail.GetWalletManagementDetailsForCaptureTableAsync}`,
      { params: params }
    );
  }
}
